// Write your code here
import './index.css'

const NotFound = () => (
  <div className="notFoundContainer">
    <h1 className="headingNotFound">Page Not Found!!</h1>
  </div>
)
export default NotFound
